import loadable from '@loadable/component';

import { isServerside } from '../../core/utils/isServerside';

const lazyGetHashHexClientside = loadable.lib(() => import('./getHashHexClientside'));

const lazyGetHashHexServerside = loadable.lib(() => import('./getHashHexServerside'));

const getHashHexGetter = async (): Promise<any> => {
  if (isServerside()) {
    const { getHashHexServerside } = (await lazyGetHashHexServerside.load()) as any;
    return getHashHexServerside;
  }
  const { getHashHexClientside } = (await lazyGetHashHexClientside.load()) as any;
  return getHashHexClientside;
};

export const getDataHash = async (data: Record<string, unknown>): Promise<string> => {
  // Encode data
  const dataString = JSON.stringify(data);
  const encoder = new TextEncoder();
  const encodedData = encoder.encode(dataString);

  // Generate hash
  const hashHex = await (await getHashHexGetter())(encodedData);

  // Prefix with 0 if the hash length is not even
  const sanitizedHashHex = `${hashHex.length % 2 ? '0' : ''}${hashHex}`;

  // Convert to decimal and extract the first 19 digits
  // to ensure a nearly 64-bit range (up to 18,446,744,073,709,551,616)
  const bn = BigInt(`0x${sanitizedHashHex}`);

  return bn.toString(10).substring(0, 19);
};
